(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("MyReactLibrary", ["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["MyReactLibrary"] = factory(require("react"), require("react-dom"));
	else
		root["MyReactLibrary"] = factory(root["React"], root["ReactDOM"]);
})(self, (__WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_react_dom__) => {
return 